import PropTypes from 'prop-types';
import DateHelper from '../../helpers/DateHelper';
import rutHelper from '../../helpers/rutHelper';

function SellerInformation(props) {
  const { sellerData } = props;
  const { sellers } = sellerData;

  return (
    <div className="mx-2 mt-4">
      <div className="d-flex align-items-center gray-light-bg">
        <div className="d-flex justify-content-center rounded-circle yellow-number-icon">
          <span className="font-weight-bold my-1">1</span>
        </div>
        <span className="dark-color font-weight-bolder ml-2 text-20">Información del vendedor</span>
      </div>
      <div className="mt-5">
        {/* S6479: the only candidate id is the RUT the user is actively typing —
              keying on it remounts the form mid-edit and loses focus. The array index IS the identity here. */}
        {
            sellers.map((seller, index) => (
              <div
                className="mt-4 seller-box gray-light-bg"
                // eslint-disable-next-line react/no-array-index-key
                key={/* NOSONAR */ `seller-${index}`}
              >
                <p className="text-secondary font-weight-bold text-14">
                  Vendedor
                  {' '}
                  {index + 1}
                </p>
                <div className="row text-16">
                  <div className="col-lg-6 col-sm-12">
                    <p>
                      {' '}
                      <strong>Rut: </strong>
                      {' '}
                      {rutHelper.toDotedRut(seller.identityCode)}
                    </p>
                    <p>
                      {' '}
                      <strong>Nombre: </strong>
                      {' '}
                      {seller.fullName}
                    </p>
                    <p>
                      {' '}
                      <strong>Fec. Adquisición: </strong>
                      {' '}
                      {DateHelper.arrayToDateES(seller.acquisitionDate)}
                    </p>
                  </div>
                  <div className="col-auto">
                    <p>
                      {' '}
                      <strong>Repertorio: </strong>
                      {seller.repertoire}
                    </p>
                    <p>
                      {' '}
                      <strong>Número: </strong>
                      {seller.number}
                    </p>
                    <p>
                      {' '}
                      <strong>De fecha: </strong>
                      {DateHelper.arrayToDateES(seller.registrationDate)}
                    </p>
                  </div>
                </div>
              </div>
            ))
          }
      </div>
    </div>
  );
}

SellerInformation.propTypes = {
  sellerData: PropTypes.object,
};

export default SellerInformation;
